import React from 'react'
import { connect } from 'react-redux'
import { GOOGLE_STREET_VIEW_KEY } from '../config/keys'
import Tooltip from './Tooltip'

const STREETVIEW = ({ lat, lng }) => `https://maps.googleapis.com/maps/api/streetview?size=400x200&location=${lat},${lng}&key=${GOOGLE_STREET_VIEW_KEY}`

const Streetview = props => {
  const { lngLat } = props
  if (!lngLat) {
    return (
      null
    )
  }
  const { lng, lat } = lngLat
  return (
    <div>
      <Tooltip id={'streetview'} title={'open Google Street View in a new tab'} leaveDelay={2000}>
        <a href={`http://maps.google.com/maps?q=&layer=c&cbll=${lat},${lng}&cbp=11,0,0,0,0`} target='_blank'>
           <img src={STREETVIEW({ lat, lng })} style={{ width: '100%' }} />
         </a>
      </Tooltip>
    </div>
  )
}

export default Streetview



// WEBPACK FOOTER //
// ./src/components/Streetview.js